import {format, parseISO} from 'date-fns';

const formatAppendixCustomString = (dateString: string): string => {
  const date = parseISO(dateString);

  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

const formatAppendixContent = (content: string) => {
  const formattedText = content.replaceAll('\n', '<br />');
  return <div dangerouslySetInnerHTML={{__html: formattedText}} />;
};

export const Appendixes: React.FC<{
  appendixes: Array<{
    id: number;
    content: string;
    createdAt: string | '';
    modifiedAt: string | '';
  }>;
}> = ({appendixes}) => {
  return (
    appendixes &&
    appendixes.length > 0 && (
      <div className="my-12 flex flex-col">
        <ul className="flex flex-col gap-8">
          {appendixes.map((appendix) => (
            <li className="w-full bg-white p-16 rounded-16 text-md text-black-1 mt-8 leading flex">
              <div className="mx-16 my-12 flex-1">
                <p className="mb-4">
                  追記 ( {formatAppendixCustomString(appendix.modifiedAt)} )
                </p>
                <div>{formatAppendixContent(appendix.content)}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  );
};
